import { Component, JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Dialog } from "../Dialog/Dialog";
import { DialogContent } from "../Dialog/DialogContent";
import { DialogFooter } from "../Dialog/DialogFooter";
import { Card } from "../../Cards/Card/Card";
import { GridContainer } from "../../Layout/Grid/GridContainer";
import { GridItem } from "../../Layout/Grid/GridItem";
import { ButtonBar } from "../../Buttons/ButtonBar/ButtonBar";
import { RightButtons } from "../../Buttons/ButtonBar/RightButtons";
import { Button } from "../../Buttons/Button/Button";

export class AlertDialog extends BaseComponent<IAlertDialogProps, IAlertDialogState>
{
    public static okButtonLabel = '';

    public render(): JSX.Element
    {
        const { show, title, onClose, message, okButtonLabel } = this.props;

        return (
            <>
                <Dialog
                    isOpen={show}
                    onOpenChange={() => onClose()}
                    width={5}
                    zIndex={10000}
                >
                    <DialogContent>
                        <Card
                            title={title}
                        >
                            <GridContainer>
                                <GridItem>
                                    {message}
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    styleType='filled'
                                    onClick={() => onClose()}
                                >
                                    {okButtonLabel ?? AlertDialog.okButtonLabel}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>
                </Dialog>
            </>
        );
    }
}

export interface IAlertDialogProps
{
    okButtonLabel?: string;
    show: boolean;
    title: string;
    message: string;
    onClose: () => void;
}

export interface IAlertDialogState { }
